import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=29523dab"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports